import React from 'react';
import PropTypes from 'prop-types';
import ScriptLoader from 'react-script-loader-hoc';
import withGlobals from '../../components/Globals';
import './theme';

const hubsUrl = process.env.HUBSUI_URL;
const { origin } = new URL(hubsUrl);
global.__webpack_hubs_public_path__ = origin;

class CollegeProfileApp extends React.PureComponent {
  static propTypes = {
    session: PropTypes.object,
    scid: PropTypes.number,
    fcService: PropTypes.object,
    apiUrl: PropTypes.string,
    history: PropTypes.object,
    scriptsLoaded: PropTypes.bool,
    isEditMode: PropTypes.bool,
    editData: PropTypes.object,
  };

  render() {
    const { session, scid, fcService, apiUrl, history, scriptsLoaded, isEditMode, editData } = this.props;
    const CollegeProfile = global.CollegeProfile ?
      global.CollegeProfile.default.default :
      null;
    return (
      <div className="fc-sui">
        {scriptsLoaded && CollegeProfile ? (
          <CollegeProfile
            session={session}
            scid={scid}
            fcService={fcService}
            apiUrl={apiUrl}
            history={history}
            origin={origin}
            isEditMode={isEditMode}
            editData={editData}
          />
        ) : null}
      </div>
    );
  }
}

export default withGlobals(ScriptLoader(hubsUrl)(CollegeProfileApp));
